

























import gsap from "gsap";
export default {
  name: "Navbar",
  data: function(): any {
    return {
      isMenuOpen: false
    };
  },
  methods: {
    //
    toggleMenu() {
      if (!this.isMenuOpen) {
        gsap
          .timeline()
          .fromTo(
            ".nav-info",
            {
              clipPath: "circle(100px at 90% -10%)"
            },
            {
              clipPath: "circle(2000px at 90% -10%)",
              ease: "power2.out",
              duration: 1
            }
          )
          .fromTo(
            "li",
            {
              opacity: 0,
              y: -50
            },
            {
              opacity: 1,
              y: 0,
              ease: "power2.out",
              duration: 1
            }
          );
        this.isMenuOpen = true;
      } else {
        gsap.timeline().fromTo(
          ".nav-info",
          {
            clipPath: "circle(2000px at 90% -10%)"
          },
          {
            clipPath: "circle(100px at 90% -10%)",
            ease: "power2.out",
            duration: 1
          }
        );
        this.isMenuOpen = false;
      }
    }
  },
  mounted: function() {
    gsap
      .timeline()
      .delay(1.5)
      .fromTo(
        ".nav-logo",
        {
          opacity: 0,
          y: -50
        },
        {
          opacity: 1,
          y: 0,
          ease: "power2.out",
          duration: 1
        }
      )
      .fromTo(
        ".nav-info",
        {
          opacity: 0,
          y: -50
        },
        {
          opacity: 1,
          y: 0,
          ease: "power2.out",
          duration: 1
        }
      );
  }
};
